/* Join requests — STORY-008.
 *
 * Two response shapes, and the difference between them is the story's central
 * security property rather than an accident of who asks.
 *
 * An OWNER sees who is asking: a name and an address, because approving is a
 * decision about a person and there is nothing to decide without them.
 *
 * A REQUESTER sees only the workspace ID they typed and when they asked.
 * Never its name, never its size, never confirmation that it exists. A pending
 * request grants nothing, and a name here would be the one thing it granted.
 */
import { z } from 'zod';
export const requestToJoinRequestSchema = z.object({
    /* The workspace ID is the Organisation's UUID — the one in every workspace
     * URL, which is exactly how somebody comes to have a colleague's. Validated
     * for SHAPE only: a malformed id is refused, an unknown one is accepted and
     * answered identically to a real one. */
    organisationId: z.string().uuid(),
});
export const ownJoinRequestSchema = z.object({
    id: z.string().uuid(),
    organisationId: z.string().uuid(),
    requestedAt: z.string().datetime(),
    expiresAt: z.string().datetime(),
});
export const ownJoinRequestsResponseSchema = z.object({
    requests: z.array(ownJoinRequestSchema),
});
export const pendingJoinRequestSchema = z.object({
    id: z.string().uuid(),
    displayName: z.string(),
    email: z.string(),
    requestedAt: z.string().datetime(),
    expiresAt: z.string().datetime(),
});
export const pendingJoinRequestsResponseSchema = z.object({
    requests: z.array(pendingJoinRequestSchema),
});
//# sourceMappingURL=join-requests.js.map